import { PlusOutlined } from '@ant-design/icons'
import { JOB_STATUS_OPTIONS } from '@configs'
import { t } from 'i18next'
import { Button, Input, SharedTable } from 'src/common'
import { SearchIcon } from 'src/components/Icon'
import { ShareSelectInput } from 'src/components/shared'
import ConfirmDeleteModal from 'src/components/staff-and-role-management/ConfirmDeleteModal'
import { AddNewForm } from './AddNewForm'
import { useListJobTable } from './useListJobTable'

interface IProps {
  onAddNew: () => void
}
const ListJobTable = ({ onAddNew }: IProps) => {
  const {
    jobs,
    columns,
    searchString,
    setSearchString,
    totalJob,
    currentPage,
    isGettingJobs,
    setStatus,
    status,
    handleClear,
    deleteId,
    setDeleteId,
    isDeletingJob,
    onDeleteJob,
    updateId,
    setUpdateId,
    callListJobAfterUpdate,
    handleTableChange,
    perPage,
    handlePaginationChange
  } = useListJobTable()


  return (
    <>
      {updateId ? (
        <AddNewForm
          title={t('evolveLanding:edit_job')}
          onCancel={() => {
            setUpdateId('')
            callListJobAfterUpdate()
          }}
          jobId={updateId}
        />
      ) : (
        <>
          <div className="flex items-center justify-between py-[1.25rem] w-full">
            <div className="flex items-center gap-x-2 w-fit">
              <Input
                className="pl-5 !h-10 "
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
                containerClassName="min-w-[350px]"
                placeholder={t('evolveLanding:search_job')}
                prefix={<SearchIcon className="pl-2" />}
              />
              <ShareSelectInput
                containerClassName="flex flex-col gap-[10px] !min-w-[200px] w-[30%]"
                inlineLabelClassName="!text-start !block !m-0"
                placeholder="Filter by status"
                data={JOB_STATUS_OPTIONS}
                onChange={(value: any) => {
                  setStatus(value)
                }}
                value={status as any}
                showArrow
              />
            </div>
            <div className="flex gap-x-2">
              <Button
                htmlType="submit"
                type="primary"
                size="middle"
                className="!bg-red-500 !border-none h-10"
                style={{
                  alignSelf: 'flex-end',
                }}
                onClick={handleClear}
              >
                {'Clear filter'}
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                size="middle"
                className="submit__btn loginselected-btn"
                icon={<PlusOutlined className="!text-[16px]" />}
                style={{
                  alignSelf: 'flex-end',
                }}
                onClick={() => {
                  onAddNew()
                }}
              >
                {'Add new'}
              </Button>
            </div>
          </div>
          <SharedTable
            rowKey="key"
            className="lg:!max-h-[60vh]"
            columns={columns}
            dataSource={jobs?.map((item: any) => {
              return {
                ...item,
                key: item?.id,
              }
            })}
            paginationProps={{
              total: !!totalJob ? +totalJob : undefined,
              pageSize: perPage,
              current: currentPage || 1,
              onChange(page, pageSize) {
                handlePaginationChange(page, pageSize)
              },
            }}
            tableProps={{ onChange: handleTableChange, loading: isGettingJobs }}
            sticky
          />
          {/* )} */}
          <ConfirmDeleteModal
            title="Delete this job "
            content="Are you sure to delete this job?"
            open={Boolean(deleteId)}
            onClose={() => setDeleteId('')}
            isLoading={isDeletingJob || false}
            onDelete={onDeleteJob}
          />
        </>
      )}
    </>
  )
}

export default ListJobTable
